<template>
  <ul class="menu-nav">
    <!-- dashboard -->
   <!--  <router-link to="/dashboard" v-slot="{ href, navigate, isActive, isExactActive }">
      <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item" :class="[
        isActive && 'menu-item-active',
        isExactActive && 'menu-item-active'
      ]">
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon2-digital-marketing"></i>
          <span class="menu-text">
            {{ $t("MENU.DASHBOARD.TITLE") }}
          </span>
        </a>
      </li>
    </router-link> -->

   <!-- mangrove info management -->
    <li class="menu-section">
      <h4 class="menu-text">{{ $t("MENU.MANGROVE_INFO.TITLE") }}</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li>

        <!--  mangrove info -->
    <router-link to="/mangrove_info" v-slot="{ href, navigate, isActive, isExactActive }">
      <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item" :class="[
        isActive && 'menu-item-active',
        isExactActive && 'menu-item-active'
      ]">
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon  flaticon-placeholder-3"></i>
          <span class="menu-text">{{ $t("MENU.MANGROVE_INFO.NAME") }}</span>
        </a>
      </li>
    </router-link>

    <!-- user management -->
    <li class="menu-section">
      <h4 class="menu-text">{{ $t("MENU.USER_MANAGEMENT.TITLE") }}</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li>

    <!-- user -->
    <router-link to="/user" v-slot="{ href, navigate, isActive, isExactActive }">
      <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item" :class="[
        isActive && 'menu-item-active',
        isExactActive && 'menu-item-active'
      ]">
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon2-user"></i>
          <span class="menu-text">{{ $t("MENU.USER_MANAGEMENT.USER") }}</span>
        </a>
      </li>
    </router-link>
  </ul>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "KTMenu",
  computed: {
    ...mapState({
      userType: state => state.auth.userType
    })
  },
  methods: {
    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    }
  }
};
</script>
